import { render, staticRenderFns } from "./AcoesInterprofissionais.vue?vue&type=template&id=cf6e4904"
import script from "./AcoesInterprofissionais.vue?vue&type=script&lang=js"
export * from "./AcoesInterprofissionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports